import { createRoot } from "react-dom/client";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { App } from "./app/app";
import * as Sentry from "@sentry/react";
import { posthogPrivacyConfig } from "./platform/analytics/posthog-privacy";

import "./index.css";

const sentryEnvironment =
  import.meta.env.MODE === "prod" ? "production" : import.meta.env.MODE;
const posthogProjectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Analytics is optional, and E2E runs must not send events to a live project.
if (
  import.meta.env.MODE !== "e2e" &&
  posthogProjectToken?.trim() &&
  posthogHost?.trim()
) {
  posthog.init(posthogProjectToken.trim(), {
    ...posthogPrivacyConfig,
    api_host: posthogHost.trim(),
    defaults: "2026-01-30",
  });
}

if (import.meta.env.PROD && sentryEnvironment !== "e2e") {
  Sentry.init({
    dsn: "https://ef6062f184ac48ef966ec187bee9e4fc@o4508613437030400.ingest.de.sentry.io/4511729523359824",
    environment: sentryEnvironment,
    dataCollection: {
      // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
      // userInfo: false,
      // httpBodies: []
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true,
  });
}

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <App />
    </PostHogErrorBoundary>
  </PostHogProvider>,
);
